export default __webpack_public_path__ + "static/media/rare3.5f11f6ce.png";